const websiteVersion = process.env.NODE_ENV === 'development' ? '' : '268f621'

export default websiteVersion
